"use client";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import useTimeout from "@/client/hooks/useTimeout";
import CoinSportNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/CoinSportNotification";
import DataSolutionsNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/DataSolutionsNotification";
import FreebetRewardNotificationView from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/FreebetRewardNotificationView";
import isCoinSportNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/helpers/isCoinSportNotification";
import JackpotWinNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/JackpotWinNotification";
import KycNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/KycNotification";
import LoyaltyNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/LoyaltyNotification";
import NftRewardNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/NftRewardNotification";
import NormalNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/NormalNotification";
import OptInNotificationView from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/OptInNotificationView";
import PopupNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/PopupNotification";
import SwitchCurrencyNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/SwitchCurrencyNotification";
import TwoFANotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/TwoFANotification";
import CasinoBoostNotification from "@/ui/Games/CasinoBoostNotification";

const MAX_TIMEOUT = 2147483647;
const DEFAULT_TIMEOUT = 10000000000;
const infinityTypes = ["FreebetsReward", "DataSolutionsNotification"];

const NotificationView: FC<NotificationViewProps> = ({
  notification,
  context,
  onClose,
}) => {
  useTimeout(
    () => {
      if (notification.sticky) {
        return;
      }
      onClose();
    },
    notification.data?.duration ??
      (infinityTypes.includes(notification.data?.type ?? "")
        ? MAX_TIMEOUT
        : DEFAULT_TIMEOUT),
  );
  const Component = getViewComponent(notification);
  if (!Component) {
    onClose();
    return null;
  }
  return (
    <div
      className={classNames(
        "fixed inset-x-4 z-50 grid max-w-md gap-2 sm:bottom-[calc(2.5rem+env(safe-area-inset-bottom,0))]",
        "sm:ltr:left-10 sm:ltr:right-0 sm:rtl:left-0 sm:rtl:right-10",
        "bottom-[calc(10rem+env(safe-area-inset-bottom,0))]",
      )}
    >
      <Component
        notification={notification}
        context={context}
        onClose={onClose}
      />
    </div>
  );
};

const getViewComponent = (notification: WorkerNotification) => {
  const notificationType = isCoinSportNotification(notification.data)
    ? "coinSport"
    : notification.type;

  switch (notificationType) {
    case "2FA":
      return TwoFANotification;
    case "loyaltyTier":
    case "loyaltyMilestone":
      return LoyaltyNotification;
    case "boost":
      return CasinoBoostNotification;
    case "kyc":
      return KycNotification;
    case "nft":
      return NftRewardNotification;
    case "site":
    case "normal":
      return NormalNotification;
    case "optin":
      return OptInNotificationView;
    case "dataSolutions":
      return DataSolutionsNotification;
    case "currency":
      return SwitchCurrencyNotification;
    case "freeBetReward":
      return FreebetRewardNotificationView;
    case "coinSport":
      return CoinSportNotification;
    case "popup":
      return PopupNotification;
    case "jackpotWin":
      return JackpotWinNotification;
    default:
      return undefined;
  }
};

export default NotificationView;
